import { useMemo, useRef } from 'react';
export const useMultiSelect = (props) => {
    const { items, defaultValue, value: values } = props;
    const defaultItemsRef = useRef(defaultValue
        ? items.filter((item) => defaultValue?.includes(item.value))
        : undefined);
    const selectedItems = useMemo(() => values !== undefined
        ? values
            .map((value) => items.find((item) => item.value === value))
            .filter((item) => !!item)
        : undefined, [items, values]);
    return {
        defaultItems: defaultItemsRef.current,
        selectedItems,
    };
};
